import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { StaffDtoSchema } from '../contracts';

const _GetStaffByIdRequestDtoSchema = z.object({
  id: z.number(),
});

const GetStaffByIdResponseDtoSchema = StaffDtoSchema;

export type GetStaffByIdRequestDto = z.infer<
  typeof _GetStaffByIdRequestDtoSchema
>;
export type GetStaffByIdResponseDto = z.infer<
  typeof GetStaffByIdResponseDtoSchema
>;

export const getStaffById = (
  params: GetStaffByIdRequestDto,
  config?: AxiosRequestConfig<GetStaffByIdRequestDto>
) => {
  const { id } = params;

  return api
    .get(`/staff/${id}`, {
      ...config,
    })
    .then(responseContract(GetStaffByIdResponseDtoSchema));
};
